import React from "react";
import { Row, Col } from "react-bootstrap";
import { CommonInput, CommonSelect } from "../../Input";
import DetailFieldWrapper from "../SendTransaction/DetailFieldWrapper";

const Step3PaymentInfo = () => {
  const [sendAmount, setSendAmount] = React.useState("0.00");
  const [receiveAmount, setReceiveAmount] = React.useState("0.00");
  const EXCHANGE_RATE = 36.45;

  const handleSendChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setSendAmount(value);
      if (value !== "" && !isNaN(value)) {
        const calculated = (parseFloat(value) * EXCHANGE_RATE).toFixed(2);
        setReceiveAmount(calculated);
      } else {
        setReceiveAmount("0.00");
      }
    }
  };

  const handleReceiveChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setReceiveAmount(value);
      if (value !== "" && !isNaN(value)) {
        const calculated = (parseFloat(value) / EXCHANGE_RATE).toFixed(2);
        setSendAmount(calculated);
      } else {
        setSendAmount("0.00");
      }
    }
  };

  return (
    <div className="mt-4">
      <Row>
        <Col md={6}>
          <DetailFieldWrapper label="Send Currency">
            <CommonSelect
              placeholder="Singapore Dollar"
              options={[{ value: "SGD", label: "Singapore Dollar" }]}
            />
          </DetailFieldWrapper>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Receiving Currency">
            <CommonSelect
              placeholder="Philippine Peso"
              options={[{ value: "PHP", label: "Philippine Peso" }]}
            />
          </DetailFieldWrapper>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <DetailFieldWrapper label="Purpose of Transfer">
            <CommonSelect
              placeholder="Select purpose"
              options={[{ value: "payroll", label: "Payroll" }]}
            />
          </DetailFieldWrapper>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Source of Funds">
            <CommonSelect
              placeholder="Select source"
              options={[{ value: "savings", label: "Savings" }]}
            />
          </DetailFieldWrapper>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <DetailFieldWrapper label="Transfer Amount">
            <div
              className="d-flex align-items-center bg-white rounded px-3"
              style={{ height: "45px", border: "1px solid #e5e7eb" }}
            >
              <span className="text-muted fw-bold me-3 fs-14">SGD</span>
              <input
                type="text"
                className="form-control px-0 border-0 bg-transparent h-100 shadow-none"
                value={sendAmount}
                onChange={handleSendChange}
              />
            </div>
          </DetailFieldWrapper>
          <div className="text-muted fs-12 mt-2">1 SGD = 36.45 PHP</div>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Receive Amount">
            <div
              className="d-flex align-items-center bg-white rounded px-3"
              style={{ height: "45px", border: "1px solid #e5e7eb" }}
            >
              <span className="text-muted fw-bold me-3 fs-14">PHP</span>
              <input
                type="text"
                className="form-control px-0 border-0 bg-transparent h-100 shadow-none"
                value={receiveAmount}
                onChange={handleReceiveChange}
              />
            </div>
          </DetailFieldWrapper>
        </Col>
      </Row>

      <Row className="mb-4 mt-3">
        <Col md={6}>
          <DetailFieldWrapper label="Fee">
            <div
              className="d-flex align-items-center bg-white rounded px-3"
              style={{
                height: "45px",
                border: "1px solid #e5e7eb",
              }}
            >
              <span className="text-muted fw-bold me-3 fs-14">SGD</span>
              <input
                type="text"
                className="form-control px-0 border-0 bg-transparent h-100"
                defaultValue="0"
              />
            </div>
          </DetailFieldWrapper>
        </Col>
        <Col md={6}>
          <DetailFieldWrapper label="Remark (optional)">
            <CommonInput placeholder="Enter remark" height="45px" />
          </DetailFieldWrapper>
        </Col>
      </Row>
    </div>
  );
};

export default Step3PaymentInfo;
